import React, { useState } from 'react';
import styled from 'styled-components';
import { useBusinessCard } from './BusinessCard';
const wai = '/images/social/wai-message2.png';

const PurchaseButtons = ({withWhatsapp = false, reverse = false, item, size = 6, onPurchase}) => {
  const instance = useBusinessCard();

  const {
    user,
    card: { products, backgroundColor, phoneNumber, waText = 'האם קיים במלאי המוצר: ' },
  } = instance;

  const sharePhoneNumber = '972' + phoneNumber?.slice(1);
  const shareTextForProduct = (product) => `${waText} ${product?.title}`;

  return (
    <IconsContainer reverse={reverse}>
      {withWhatsapp && <Badge
        href={`https://wa.me/${sharePhoneNumber}?text=${shareTextForProduct(
          item,
        )}`}
        rel="noopener noreferrer"
        target="_blank"
      >
        <BadgeImage src={wai} />
      </Badge>}
      <IconButton>
        <ActionLink
          size={size}
          onClick={(e) => {
            e.stopPropagation()
            onPurchase();
          }}
        >
          <Icon size={size} src="/images/ic_paypal.png" />
        </ActionLink>
      </IconButton>
      <IconButton>
        <ActionLink
          size={size}
          onClick={(e) => {
            e.stopPropagation()
            onPurchase();
          }}
        >
          <Icon size={size} src="/images/ic_bit.png" />
        </ActionLink>
      </IconButton>
      <IconButton>
        <ActionLink
          size={size}
          onClick={(e) => {
            e.stopPropagation();
            onPurchase();
          }}
        >
          <Icon size={size} src="/images/ic_pepper.png" />
        </ActionLink>
      </IconButton>
    </IconsContainer>
  );
};

const IconButton = styled.div`
  margin-right: 0.5em;
`;
const IconsContainer = styled.div`
  display: flex;
  flex-direction: ${(p) => p.reverse ? 'row-reverse' : 'row'};
  align-items: center;
`;

const ActionLink = styled.button`
  background: none;
  box-sizing: border-box;
  outline: none;
  width: ${(p) => p.theme.dimensions.vw(p.size)}px;
  height: ${(p) => p.theme.dimensions.vw(p.size)}px;
  color: ${(p) => p.theme.textColor};
  border: none;
  display: flex;
  justify-content: center;
  align-items: center;

  > svg {
    width: ${(p) => p.theme.dimensions.vw(p.size)}px;
    height: ${(p) => p.theme.dimensions.vw(p.size)}px;
  }
`;

const Icon = styled.img`
  width: ${(p) => p.theme.dimensions.vw(p.size)}px;
  height: ${(p) => p.theme.dimensions.vw(p.size)}px;
`;

const BadgeImage = styled.div`
  background-image: url(${(p) => p.src});
  background-position: center;
  background-repeat: no-repeat;
  background-size: contain;
  width: 5.6em;
  height: 2.2em;
`;

const Badge = styled.a`
  outline: none;
  cursor: pointer;
`;

export default PurchaseButtons;
